import React from "react";
import { BackButton } from "react-onsenui";

export default class ConditionalBackButton extends React.Component {
  render() {
    const { navigator } = this.props;
    if (navigator && navigator.pages && navigator.pages.length > 1) {
      return <BackButton />;
    } else {
      return <div />;
    }
  }
}
